
<ng-container *ngFor="let plugin of plugins;let idx = index;">
    <fdm-bucket [plugin]="plugin" [@slideInOut]></fdm-bucket>
</ng-container>